<template>
  <div id="workTable">
    <div class="home-header" v-show="!login">
      <div class="title-first">{{website.web_title}}：快速克隆，高效创作</div>
      <div class="title-second">
        手机在线数字人克隆平台，快速完成形象及声音定制，AI文案创作大模型，一键生成口播视频
      </div>
      <!-- <div class="title-third">
        一键生成令人拍案叫绝的原创内容，大幅提高你的工作效率
      </div> -->
      <div class="free" @click="jumppage(1, 1)">免费体验</div>
      <div class="title-fourth">找到你想创作的类型，免费体验AI写作</div>
      <div class="title-guide">
        <img
          src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAB4AAAAoCAYAAADpE0oSAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAOlSURBVHgBxZffaxRXFMfPuXc2Gbe7Nba1WKgoxdZk3dlaIthSkGgeiqWFRrBkg1qktKW1tqXQHw8t6ZMvloL+AdWGdCcsAaEUK8WfKPjiQ3THuEZFEPEXaFbHmU12Z+7xTNSYYNRkdh0/sMyd2XPvd+45c+89BzI520rl7FUQMRohLpCoNULECP41eOhVIWIEIAp4BmhA5GugxSBiWBjKvlIJiBgNhLgliJ6HiOEZq+tIMBciRiOCEn9gCyBiBApxia+vQsQIUDSECNHPWAi0gPC1Rdsp0t1LjIKwAOi5htluCiJEFDv1IV7LF7EB2yBC7m6XiAeRaDVEyJiwUqIXAd41/qY5T+qQzpfXG6Zz3Mg5JzOmswVCMiYs/cYjgDRKwv3mccbpPncN+qqHXbSHgHYSwFdGX3kjhBU+sQEdArmNd7Dvlu4YbnqUMf+/mS87C9n4T1ZXYis/2U2+9wGEYPxI1PSRbbyeHW+WvvXR5mqxB2rPg3uKIcomqEV4oGNOySO1AYHWZ0z7t6nN0dVIjAuxu9/kve8Q1CIcMNiV3K+U+oKj/qORc3uXmsMLJ+tCQYFqD5pG7tbPCDi/StADIcCpHjbnndaYD/3c1PkD2qXAN1+elzx646r7GSnaws/+QsRvecY/WNnE71Av4YCFO0hPNt7+hOO+mUAsuWftsX81bp33UW4a7NT/g5DgdIxa+u0lWkV7iY0lz/5XfhkoZBMroQamJTyRtGm3IYgDBGqllU0ehJDMOMO8K8ZbLMju7m4KnaGG60jyS06ZWnc1l7+HqDFM+5e06ZTT/aMZCMGMYzxZ3NnLQ8yXI7OWD2zE0kz61lRF+DK+jguCuKe7/7/yD8Vn0rcm4cGP8QrnbO+z215/8bbbs3Ytyen2rbluKqxLFHyqrOK13V7scMxF28+M525EhOk+ew03HgppTTGeSCo3/JaE2H7OZopSj68e6MBSJj+ymHy/SCg/tDr1f5+KcEBLn53m02s3D1uWgO8NFPULRrNznR17reI6y05/Ote+b1vXEvVUZ9KqQmUFO1b4pA6nW8of8UucZae/EYvHJ635us74Pq3HKFYZcv/g0b9mgRKfZsEZ7hFU37GyTccCm7oX5ane0VT1nNOFQgUzHb4nGqAhxv5szdPssRuoM1L6+0jhvCmdSWBUfDdIrT6vu6tT+ZsvgJLLBYh2zpszXBSu4OU0qTxSpDY9lRhPpO0AadcuVw0hqm+DwnaBtIzdr+4ANfhVogfdi5wAAAAASUVORK5CYII="
        />
      </div>
    </div>
    <div class="paddingbox">
      <div class="classification">
        <div class="swiper">
          <swiper :options="swiperOption" ref="mySwiper">
            <swiper-slide :class="swiperIndex == -1 ? 'swiperOn' : ''"
              ><span data-id="0" :data-index="-1">全部</span></swiper-slide
            >
            <swiper-slide
              :class="swiperIndex == index ? 'swiperOn' : ''"
              v-for="(item, index) in swiperdata"
              :key="index"
              ><span :data-index="index" :data-id="item.id">{{
                item.title
              }}</span></swiper-slide
            >
          </swiper>
          <div class="swiper-prev">
            <svg
              style="transform: rotate(180deg)"
              t="1704181764265"
              class="icon"
              viewBox="0 0 1024 1024"
              version="1.1"
              xmlns="http://www.w3.org/2000/svg"
              p-id="4568"
              width="64"
              height="64"
            >
              <path
                d="M383.291616 808.954249c-5.175883 0-10.353812-1.950422-14.338566-5.862521-8.064676-7.919367-8.182356-20.877493-0.26299-28.942169l273.602402-278.620695L368.69006 216.907145c-7.919367-8.064676-7.801686-21.022803 0.26299-28.942169 8.065699-7.918343 21.022803-7.80271 28.942169 0.26299l287.685141 292.960285c7.818059 7.961322 7.818059 20.717857 0 28.67918L397.895219 802.826692C393.887952 806.907637 388.591319 808.954249 383.291616 808.954249z"
                p-id="4569"
                fill="#ffffff"
              ></path>
            </svg>
          </div>
          <div class="swiper-next">
            <svg
              t="1704181764265"
              class="icon"
              viewBox="0 0 1024 1024"
              version="1.1"
              xmlns="http://www.w3.org/2000/svg"
              p-id="4568"
              width="64"
              height="64"
            >
              <path
                d="M383.291616 808.954249c-5.175883 0-10.353812-1.950422-14.338566-5.862521-8.064676-7.919367-8.182356-20.877493-0.26299-28.942169l273.602402-278.620695L368.69006 216.907145c-7.919367-8.064676-7.801686-21.022803 0.26299-28.942169 8.065699-7.918343 21.022803-7.80271 28.942169 0.26299l287.685141 292.960285c7.818059 7.961322 7.818059 20.717857 0 28.67918L397.895219 802.826692C393.887952 806.907637 388.591319 808.954249 383.291616 808.954249z"
                p-id="4569"
                fill="#ffffff"
              ></path>
            </svg>
          </div>
        </div>

        <el-input placeholder="搜索模板" v-model="params.keyword">
          <i slot="prefix" class="el-input__icon el-icon-search"></i>
        </el-input>
      </div>

      <div class="list">
        <el-row :gutter="20" v-if="list.length > 0">
          <el-col :span="6" v-for="(item, index) in list" :key="index">
            <div
              :class="['box', item.type == 1 ? 'video' : '']"
              @click="jumppage(item.type, item.id)"
            >
              <img :src="listTip" alt="" class="tip" v-show="item.type == 1" />
              <img :src="item.image" alt="" class="icon" />
              <p class="title">{{ item.title }}</p>
              <p class="subtitle">{{ item.sub_title }}</p>
            </div>
          </el-col>
        </el-row>
        <div v-else  class="no-data-box">
          <div class="no-data">
            <div>
              <img
                src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACwAAAAiCAYAAAAkjjtxAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAM9SURBVHgB7ZddSBRRFMfPjCvszjyoaQlmOCu4pGglGJoPai4EoulGCkqIQj1YLwW91mP00EOvggVlL0IGQiUV+JEU9hhYkkVYacW6WpaMX7s70z13d7bd2cn9GGfHwB8MM3P33Ln/mf2fc+9lQANXe48gAXSBibAAd4cGej+p2y1awRLDjPEcJ/C8DcxAFNdAXF11kcvymMGutgtHmjvOy1PT72WzmHo7I6OGpvaeOrU+Vt0gWeSufXuzobS4CMyitMQBPEf/3Vr1b6xGvMtMsQr1NVXAMky3uj3Cw2gHCWTBWXssIsjv98PGxgYYSXp6Oj0UqioOw8MnYwLa4tFA7zhoCf6XHURRBEmSwEi8Xi9kZGSE7hVbrIiraItxpV1tiSg7bG5uGi4WIblGRYejZYuQYFcgI4XmhvqITig4Vahth7ZATeHVIiRYZllqB3tBfqgDflmfzwepAscKHw9tgZoYhmmBKMGyXFdZcSjiAevr65Bqom1RCQxAt3JPBSt2cNb8rQ7oqVR+XQW0II6tUFbswFOmYgsqWMsO+KapSDY1KDY8b9S2YINBUXYwuu5uxVa2YLXsgFbAycIs1MkXbgsL2oG3WWmRXvAs0YA1kmzeGOWMs9mA46yQDItLP2PG/F4RwWoNPB8tgYfbs9TCkFXRLGkTIAlO1FfDmdamhPpcv9kH7z7MQpIs49QsnGw4rhTpuCHLTxh4MJyQYPyyKPZsZxsUCvshEYLjZdK1hL3gAFk/OBJ6QKDyDBMRy5CTnRlXH0/QCmUlRREVKR7cnh/0zEKSFAYHnP/mjrvPl/nvNFcSFRtO0oJ5nqOruqejL+Lu82z0JVQmaD01SQtGzhEvTs98hKHHIzFj+/rvA5uWBh2nG0EPFtCBXcgnCdQKt+8NUn+eanQSP2dFxGCi9fUPwtxXN1zs6aTlSQ+6BCO4HM0lIm4R0Zev3oCDDjvk7MkKicWqgCKvXblEX1AvugUj6Es8RiZewRtSfhYWAxNQXl4udLa7tnVDuy2CFZxkh4CHkehKOjPYFWw0u4KNxoJz++jzSVqOdjKzn+cCWyWybBsbmZisg/+A6qPldxi8IHu6Wtj5/CIb0dd/AHXns06xLbPKAAAAAElFTkSuQmCC"
              />
            </div>
            <div  class="no-data-title">
              <span>没找到你想要的模板？ 要不试试 换个关键词<br/>或者</span><span  class="clear-title" @click="status=true">反馈给我们</span>
            </div>
          </div>
        </div>
      </div>
    </div>
    <feedback v-if="status"></feedback>
  </div>
</template>

<script>
import { getIndexData } from "@/api/index";
import feedback from "@/components/feedbacktc"
export default {
  components:{
    feedback
  },
  data() {
    return {
      status:false,
      loginbox: false,
      params: {
        cid: 0,
        keyword: "",
      },
      login: "",
      keyword: "",
	  website: this.$store.website,
      swiperIndex: -1,
      swiperOption: {
        slidesPerView: 9,
        spaceBetween: 8,
        navigation: {
          prevEl: ".swiper-prev",
          nextEl: ".swiper-next",
        },
        on: {
          click: (e) => {
            this.swiperClick(e);
          },
        },
      },
      swiperdata: [],
      listTip: require("../../assets/fun/tag-video-2106bf46.png"),
      list: [],
    };
  },
  mounted() {
    if (localStorage.getItem("gpt-token")) {
      this.login = true;
    } else {
      this.login = false;
    }
    this.getIndexData();
    window.addEventListener("keydown", (event) => {
      if (event.key === "Enter") {
        this.getIndexData();
      }
    });
  },
  methods: {
    closelogin() {
      this.loginbox = false;
    },
    swiperClick(e) {
      this.params.cid = e.target.getAttribute("data-id");
      this.swiperIndex = e.target.getAttribute("data-index");
      this.getIndexData();
    },
    getIndexData() {
      var that = this;
      getIndexData(this.params).then((response) => {
        that.swiperdata = response.data.category;
        that.list = response.data.template;
      });
    },
    jumppage(type, id) {
      console.log(type);
      if (type == 2) {
        this.$router.push({ path: "/copywriting/" + id });
      } else {
        if (id == 1) {
          this.$router.push({ path: "/microvideo?id=" + id });
        } else if (id == 2) {
          this.$router.push({ path: "/customized?id=" + id });
        } else if (id == 3) {
          // this.$router.push({ path: "/face?id=" + id });
          // this.$router.push({ path: "/face"});
		  this.$message({
		  	 message:'暂未开放'
		  })
        }else if (id == 4) {
        this.$router.push({ path: "/clone" });
      }
      }
    },
  },
};
</script>

<style lang="less">
#workTable {
  flex: 1 0 10%;
  .home-header {
    background-image: url(../../assets/home-header-bg-857037db.png);
    height: 267px;
    padding: 43px 68px 24px;
    flex-direction: column;
    position: relative;
    background-size: contain;
    border-radius: 6px;
    text-align: center;
    .title-first {
      font-weight: 700;
      font-size: 40px;
      color: #2c3e50;
      margin-bottom: 4px;
    }
    .title-second,
    .title-third {
      font-size: 16px;
      color: #718096;
      margin-bottom: 2px;
    }
    .free {
      width: 165px;
      height: 52px;
      background: linear-gradient(
          106.92deg,
          #10c5fe 14.83%,
          #1093fe 31.52%,
          #4f4fe7 65.11%,
          #b60cb9 91.29%,
          #e0caf5 102.83%
        ),
        #2d8af5;
      box-shadow: 0 2px 8px rgba(52, 70, 237, 0.1);
      border-radius: 54px;
      color: #fff;
      font-size: 16px;
      cursor: pointer;
      font-weight: 700;
      display: flex;
      align-items: center;
      justify-content: center;
      margin: 20px auto 0;
    }
    .title-fourth {
      font-style: normal;
      font-weight: 400;
      font-size: 14px;
      line-height: 22px;
      position: absolute;
      left: 68px;
      top: 221px;
      color: rgba(44, 62, 80, 0.5);
    }
    .title-guide {
      position: absolute;
      left: 200px;
      top: 244px;
    }
  }
  .paddingbox {
    padding: 20px 32px;
  }
  .classification {
    display: flex;
    justify-content: space-between;
    align-items: center;
    .swiper {
      max-width: 917px;
      min-width: 618px;
      position: relative;
    }
    .swiper:hover .swiper-prev,
    .swiper:hover .swiper-next {
      opacity: 1;
    }
    .swiper-container {
      align-items: center;
      margin-left: 0;
      margin-right: 0;
    }
    .swiper-slide {
      width: 94px !important;
      height: 28px;
      color: #4e5969;
      font-size: 14px;
      line-height: 22px;
      font-weight: 700;
      cursor: pointer;
      text-align: center;
      display: flex;
      align-items: center;
      justify-content: center;
    }
    .swiperOn {
      background: #f2f4ff;
      border-radius: 32px;
      color: #2d8af5;
    }
    .swiper-next {
      position: absolute;
      z-index: 100;
      width: 20px;
      height: 100%;
      border-radius: 8px 0 0 8px;
      cursor: pointer;
      background: rgba(0, 0, 0, 0.4);
      color: #fff;
      right: 0;
      top: 0;
      display: flex;
      align-items: center;
      justify-content: center;
      -webkit-transform: translateZ(0);
      opacity: 0;
      svg {
        width: 14px !important;
        height: 14px !important;
      }
    }
    .swiper-prev {
      position: absolute;
      z-index: 100;
      width: 20px;
      height: 100%;
      border-radius: 0 8px 8px 0;
      cursor: pointer;
      background: rgba(0, 0, 0, 0.4);
      color: #fff;
      left: 0;
      top: 0%;
      display: flex;
      align-items: center;
      justify-content: center;
      -webkit-transform: translateZ(0);
      opacity: 0;
      svg {
        width: 14px !important;
        height: 14px !important;
      }
    }

    .el-input {
      width: 198px;
    }
  }

  .list {
    margin-top: 32px;
    .box {
      display: block;
      position: relative;
      width: 100%;
      height: 126px;
      box-sizing: border-box;
      padding: 20px;
      background-color: #fdfeff;
      border-radius: 8px;
      cursor: pointer;
      margin-bottom: 20px;
      border-width: 1px;
      border-style: solid;
      border-color: #f4f5f7;
      transition: all 0.3s ease;
      text-decoration: none;
      position: relative;
      .icon {
        width: 22px;
      }
      .title {
        font-weight: 700;
        font-size: 18px;
        color: #3b3b3b;
        margin-top: 10px;
      }
      .subtitle {
        font-weight: 400;
        font-size: 12px;
        line-height: 20px;
        color: #b2b4b6;
        margin-top: 4px;
      }
      .tip {
        width: 52px;
        height: 52px;
        background-size: cover;
        position: absolute;
        top: -5px;
        right: -6px;
      }
    }
    .video {
      border: 1px solid rgba(33, 108, 220, 0.2);
      background-image: linear-gradient(99deg, #f4fbff 12.37%, #fbfdff 94.32%);
    }
    .box:hover {
      box-shadow: 0 0 10px rgba(36, 121, 241, 0.13);
      transform: translate3d(0, -5px, 0);
    }
  }
  .no-data-box{
    text-align: center;
    margin-top: 300px;
    .clear-title{
      color: #2d8af5;
      cursor: pointer;
    }
  }
}
</style>